import * as Yup from "yup";

export const newUserFormValidationSchema = (isAddMode) =>
  Yup.object({
    name: Yup.string()
      .required("Name is Required")
      .max(40, "Name must be at most 40 characters long"),

    login: Yup.string()
      .required("Email is required")
      .matches(/^[a-zA-Z]/, "Email must start with a letter (A-Z, a-z)")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+$/,
        "Email must contain '@' followed by a valid domain"
      )
      .matches(
        /\.[a-zA-Z]{2,4}$/,
        "Email must end with a valid top-level domain (.com etc.)"
      ),

    password: isAddMode
      ? Yup.string()
          .required("Password is Required")
          .min(8, "Password must be at least 8 characters long")
          .matches(
            /[a-z]/,
            "Password must contain at least one lowercase letter"
          )
          .matches(
            /[A-Z]/,
            "Password must contain at least one uppercase letter"
          )
          .matches(/[0-9]/, "Password must contain at least one number")
          .matches(
            /[@$!%*?&#]/,
            "Password must contain at least one special character"
          )
      : Yup.string().notRequired(),
    phone: Yup.string()
      .matches(/^[0-9]+$/, "Only numbers are allowed")
      .required("Phone number is required")
      .min(8, "Phone number must be at least 8 digits")
      // .max(15, "Phone number must be at most 15 digits"),
  });
